// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BHOG","label":"styles_label__DIpKw"};